import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import SidebarMenu from "../../../Components/SidebarMenu";
import api from "../../../Services/api";
import { Page } from "../../SignedOut/Cadastro/styles";
import { PageTitle, RegisterInput } from "../CadastrarMedico/styles";
import {
  Option,
  OptionBtn,
  OptionTitle,
  PageOptions,
} from "../Creditos/styles";
import { ToastContainer, toast } from "react-toastify";
import { Boxcentral } from "../ValorCredito/styles";
import "react-toastify/dist/ReactToastify.css";
import PageContainer from "../../../Components/PageContainer";
import ReactLoading from "react-loading";

export default function RepassePagamento() {
  const history = useHistory();
  const [valorAtual, setValorAtual] = useState(0);
  const [novoValor, setNovoValor] = useState(0);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    try {
      const response = await api.get("/admin/valor-margem");
      const dados = response.data;
      console.log(dados);
      console.log("response", response.data);
      setValorAtual(dados);
    } catch (error) {
      console.log(error.response.data);
      console.log("PQP deu errooo");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleConfirmChanges = async () => {
    setLoading(true);
    try {
      const novoValorCalculado = parseFloat(novoValor) / 100;
      const response = await api.patch("/admin/valor-margem", {
        valor: novoValorCalculado,
      });
      setValorAtual(novoValorCalculado);
      setNovoValor(0);
      toast.success("Alterações confirmadas com sucesso!");
    } catch (error) {
      console.log(error.response.data);
      toast.error("Erro ao confirmar as alterações.");
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    let newValue = parseFloat(e.target.value);
    if (!newValue) {
      newValue = 0;
    }
    if (newValue < 0) {
      newValue = 0;
    } else if (newValue > 100) {
      newValue = 100;
    }
    setNovoValor(newValue);
  };

  return (
    <Page>
      <SidebarMenu />
      <PageContainer>
        <PageTitle>Repasse do pagamento</PageTitle>
        <PageOptions>
          <Option>
            <OptionTitle>Digite o valor que você deseja (%): </OptionTitle>
            <RegisterInput
              placeholder="Digite o Valor"
              value={novoValor}
              onChange={handleInputChange}
            />
          </Option>
          <Option>
            <OptionTitle>Valor do repasse é {valorAtual * 100}%</OptionTitle>
          </Option>
          <Boxcentral>
            <OptionBtn disabled={loading} onClick={handleConfirmChanges}>
              {
              loading
              ?
                <ReactLoading
                  type="spin"
                  color="#ffffff"
                  height={"30px"}
                  width={"30px"}
                />
              :
                "Confirmar Mudancas"
              }
            </OptionBtn>
          </Boxcentral>
        </PageOptions>
      </PageContainer>
    </Page>
  );
}
